<script lang="ts">
  // UI components
  import { Input } from '$lib/components/ui/input';
  import { Label } from '$lib/components/ui/label/index.js';

  // RoastLog
  import { coffedModbusSettings } from '$lib/PersistedState.svelte';
</script>

<div class="grid grid-cols-1 gap-2">
  <div>
    <Label>Host</Label>
    <Input
      type="text"
      placeholder="192.168.1.100"
      class="max-w-xs"
      bind:value={coffedModbusSettings.current.host}
    />
  </div>
</div>
